// extracted by mini-css-extract-plugin
export default {"leaderboard":"leaderboard_ouI8o","list":"list_Sfosm","line":"line_d8L93","num":"num_TOF3g","emoji":"emoji_qTcma"};